// libraryAccess.js — who may change a library carton (V2 #93).
//
// Rename, Share, Save to library and Delete are offered only on a carton of the
// user's OWN organisation, and only to its owner or that organisation's admin —
// superuser or not (decision 3 on #92). A superuser can still SEE other
// organisations' cartons; changing them is the Control Center's job (#98). The
// backend applies the same rule (library router `_require_owner_or_admin`).
//
// Pure, mirrored to .cjs (node tools/gen-cjs-mirrors.cjs) and tested by
// src/libraryaccess.test.js.

/** True when `me` may rename, share, save to library or delete `carton`. */
export function canManageCarton(carton, me) {
  if (!carton || !me) return false;
  if (!carton.org_id || carton.org_id !== me.org_id) return false;
  return carton.owner_id === me.id || me.role === 'admin';
}
